import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { fetchingCampaigns, updateImagesLoaded } from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(fetchingCampaigns.started, state => ({
        ...state,
        loading: true
    }))
    .case(
        fetchingCampaigns.done,
        (state, { result: { openCampaigns, upcomingCampaigns, tabs } }) => ({
            ...state,
            openCampaigns: [...openCampaigns],
            upcomingCampaigns: [...upcomingCampaigns],
            tabs: [...tabs],
            loading: false
        })
    )
    .case(fetchingCampaigns.failed, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    }))
    .case(updateImagesLoaded, (state, payload) => ({
        ...state,
        imagesLoaded: payload,
    }));

export default reducer;
